// extracted by mini-css-extract-plugin
export default {"question":"_1AAC1Shc","conclusion":"_2Yfuk9Q0"};